var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126.000000, -135.000000)",
    id: "check"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#22252B",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#F1F3F5",
    strokeWidth: 2,
    strokeLinecap: "square",
    points: "8 13.1953895 11.0486623 15.8095124 16.8447885 9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheck);
export default __webpack_public_path__ + "static/media/SelectedCheck.34e50fd782bf86737899ed5a2f24e43a.svg";
export { ForwardRef as ReactComponent };